import type {
  PartnerMediaFileSortColumn,
  SortOrder,
} from "Infrastructure/Api/Api";

export const MEDIA_FILES_QUERY_KEYS = {
  all: ["MEDIA_FILES"] as const,
  list: (
    offset?: number,
    limit?: number,
    searchQuery?: string | null,
    sortBy?: PartnerMediaFileSortColumn,
    sortOrder?: SortOrder,
  ) =>
    [
      ...MEDIA_FILES_QUERY_KEYS.all,
      "LIST",
      offset,
      limit,
      searchQuery,
      sortBy,
      sortOrder,
    ] as const,
} as const;
